import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePremiumAccess } from '@hellodarwin/app-core/lib/providers/premium-access-provider';
import Button from '@hellodarwin/core/lib/components/common/button';
import Div from '@hellodarwin/core/lib/components/common/div';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import GrantCard from '@hellodarwin/core/lib/components/grants/card';
import { useNavigate } from '@hellodarwin/core/lib/features/providers/location-provider';
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { useMemo, useState } from 'react';
import { useTheme } from 'styled-components';
import { AssistantMessageFormatter } from '../../../../services/AssistantMessageFormatter';
const SHOW_MORE_COUNT = 5;
export const GrantResultsCard = ({ tool }) => {
    const grants = AssistantMessageFormatter.extractGrantResults(tool);
    const { t } = useTranslations();
    const { paths } = usePlatform();
    const theme = useTheme();
    const navigate = useNavigate();
    const [showCount, setShowCount] = useState(SHOW_MORE_COUNT);
    const handleShowMore = () => setShowCount((previousValue) => previousValue + SHOW_MORE_COUNT);
    const grantsCountHidden = useMemo(() => Math.max(0, grants.length - showCount), [showCount, grants.length]);
    const { accessLevel } = usePremiumAccess();
    const ctaText = accessLevel === 'admin'
        ? t('assistant|assistant_tool_search_grants_see_grant')
        : undefined;
    const handleClickCta = (grant) => {
        if (accessLevel === 'admin') {
            navigate(paths.grants + '/' + grant.grant_id);
        }
    };
    if (grants.length === 0) {
        return null;
    }
    return (_jsxs(Div, { style: {
            marginTop: `${theme.spacing.md}px`,
            backgroundColor: theme.colors.beige_2,
            borderRadius: theme.border_radius.md,
            padding: `${theme.spacing.lg}px ${theme.spacing.md}px ${theme.spacing.lg}px ${theme.spacing.md}px`,
            border: `1px solid ${theme.colors.grey_4}`,
        }, children: [_jsx(Div, { flex: "row", align: "center", justify: "space-between", style: {
                    marginBottom: `${theme.spacing.md}px`,
                }, children: _jsx(Typography, { elementTheme: "h5", style: { fontWeight: theme.fontWeights.semibold }, children: t('assistant|assistant_tool_search_grants_programs_identified') }) }), _jsxs(Div, { flex: "column", gap: theme.spacing.md, children: [grants.slice(0, showCount).map((grant) => {
                        return (_jsx(GrantCard, Object.assign({}, grant, { parentPath: paths.grants, openInNewTab: true, type: accessLevel === 'admin' ? 'detail' : 'preview', ctaText: ctaText, handleClickCta: handleClickCta }), grant.grant_id));
                    }), grantsCountHidden > 0 && (_jsx(Button, { onClick: handleShowMore, isLink: true, style: { alignSelf: 'center', marginTop: `${theme.spacing.sm}px` }, children: t('assistant|tool_search_grants_show_more_grants', {
                            grantsCount: grantsCountHidden,
                        }) }))] })] }));
};
export default GrantResultsCard;
